import { render, staticRenderFns } from "./StudipWysiwyg.vue?vue&type=template&id=1b9bc596&"
import script from "./StudipWysiwyg.vue?vue&type=script&lang=js&"
export * from "./StudipWysiwyg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports